import { ActionSpeed } from "../actions/Action";
import { Actor, Encumbrance } from "../actors/Actor";
import { Attack } from "./Item";

export const damageWithForce = (baseDamage: number, force: number) => {
  return (baseDamage + 2 * force) * (1 + 0.05 * force);
};

export const getDamageReduction = (armor: number) => {
  return 1 - (0.05 * armor) / (1 + 0.05 * Math.abs(armor));
};

export const getEquipmentWeight = (actor: Actor) => {
  return (
    (actor.wielding.left?.breed.stats.weight || 0) +
    (actor.wielding.right?.breed.stats.weight || 0) +
    (actor.wearing.armor?.breed.stats.weight || 0)
  );
};

export const getActorArmor = (actor: Actor) => {
  return (
    (actor.attributes.armor || 0) +
    (actor.wielding.left?.breed.stats.armor || 0) +
    (actor.wielding.right?.breed.stats.armor || 0) +
    (actor.wearing.armor?.breed.stats.armor || 0)
  );
};

export const getActorWeight = (actor: Actor) => {
  return (
    (actor.wielding.left?.breed.stats.weight || 0) +
    (actor.wielding.right?.breed.stats.weight || 0) +
    (actor.wearing.armor?.breed.stats.weight || 0)
  );
};

export const getWeightLoad = (weight: number, max: number) => {
  return Math.floor((100 * weight) / max);
};

export const getWeightLevel = (weight: number, max: number) => {
  const pct = getWeightLoad(weight, max);
  if (pct <= 25) {
    return Encumbrance.LIGHT;
  } else if (pct <= 75) {
    return Encumbrance.MEDIUM;
  }
  return Encumbrance.HEAVY;
};

export const weightToActionSpeed = (weightLevel: Encumbrance) => {
  switch (weightLevel) {
    case Encumbrance.LIGHT:
      return ActionSpeed.FAST;
    case Encumbrance.MEDIUM:
      return ActionSpeed.MEDIUM;
    case Encumbrance.HEAVY:
      return ActionSpeed.SLOW;
  }
};

export const reduceDamage = (damage: number, reduction: number) => {
  return Math.max(Math.round(damage * reduction), 1);
};

export const hasStrength = (a: Actor, attack: Attack) => {
  return (attack.strength || 0) <= a.attributes.strength;
};
